<template>
    <base-page>
        <div class="w-full h-full flex flex-col justify-center bg-gray-100">
            <div class="w-full h-14 flex justify-center items-center border-b border-gray-300">
                <div class="flex w-full max-w-[1368px] pl-6 pr-8 space-x-4 items-center h-10">
                    <div class="w-full flex items-center">
                        <QuickSearch 
                            class="pt-1.5 w-full"
                            placeholder="Search"
                            @quick-search="quickSearch"
                            @clear-quick-search="clearQuickSearch"
                        />
                    </div>
                    <!-- <div>
                        <button @click="showCreateForm" class="rounded-sm bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 text-white text-lg flex items-center justify-center h-7 w-7 hover:shadow-md active:bg-dark-primary">
                            +
                        </button>
                    </div> -->
                </div>
            </div>
            <div class="w-full h-[calc(100%-3.5rem)] flex justify-center">
                <div class="flex flex-col w-full max-w-[1368px]">
                    <div class="w-full h-full flex">
                        <div class="p-8 w-72 h-full border-r border-gray-300 overflow-y-auto">
                            <div class="space-y-1 pb-4 text-sm" v-for="result in results.data" :key="result.id">
                                <div class="text-gray-900 font-medium">{{ result.label }}</div>
                                <LabelRow
                                    v-for="subGroup in result.sub_groups" 
                                    :key="subGroup.id"
                                    :row="subGroup"
                                    :selected-row="selectedSubGroup"
                                    @click="selectSubGroupById(subGroup.id)" 
                                />
                            </div>
                        </div>
                        <div class="w-full h-full overflow-y-auto relative">
                            <SubGroupContainer 
                                v-if="selectedSubGroup" 
                                :subGroup="selectedSubGroup"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </base-page>
</template>

<script setup>
import { ref, reactive, watch} from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import QuickSearch from '../base-components/QuickSearch.vue';
import LabelRow from './LabelRow.vue';
import SubGroupContainer from './SubGroupContainer.vue';
import { getTrainingDocumentGroups } from '@/services/TrainingDocument';

const store = useStore();
const $toast = useToast();

const moduleName = ref('Training Documents')
const isLoading = ref(false)
const selectedSubGroup = ref(null)

const quickSearchFilter = ref(null)

watch(() => quickSearchFilter.value, () => {
    filterVisibleDocuments()
})


const results = reactive({
    data: [],
    next: null,
    prev: null,
    count: null,
    page: 1,
    pageSize: null,
    totalPages: 0
})


function quickSearch(filterValue) {
    // console.log('quickSearch', filterValue)
    if(filterValue) {
        quickSearchFilter.value = filterValue.toLowerCase()
    } else {
        quickSearchFilter.value = null
    }
}

function clearQuickSearch() {
    // console.log('clearQuickSearch')
    quickSearchFilter.value = null
}

function filterVisibleDocuments() {
    console.log('filterVisibleDocuments')
}


function setResults(response){
    if(response) {
        if(response.status == 200) {
            let resetCount = false
            if(response.data.results) {
                results.data = response.data.results
                results.next = response.data.next ? `&page=${response.data.page + 1}` : null
                results.prev = response.data.previous ? `&page=${response.data.page - 1}` : null
                results.count = response.data.count
                results.page = response.data.page
                results.pageSize = response.data.results.length
                results.totalPages = response.data.num_pages
            } else {
                results.data = response.data
                results.next = null
                results.prev = null
                results.count = response.data.length
                results.page = null
                results.pageSize = null
                results.totalPages = null
                resetCount = true
            }
            filterVisibleDocuments()
            // getFilteredResults(resetCount)
            // handleRowOpening()
        } else {
            $toast.open({
                message: `Error receiving ${moduleName.value} results.`,
                type: 'error',
                duration: 5000
            })
        }
    }
}

function selectSubGroupById(subGroupId) {
    let subGroups = []
    results.data.forEach((group) => {
        console.log(group)
        subGroups.push(...group.sub_groups)
    })
    selectedSubGroup.value = subGroups.find((subGroup) => subGroup.id == subGroupId)
}

function selectFirstSubGroup() {
    let subGroups = []
    results.data.forEach((group) => {
        console.log(group)
        subGroups.push(...group.sub_groups)
    })
    selectedSubGroup.value = subGroups[0]
}


async function loadTrainingDocuments(fetchFilter='') {
    isLoading.value = true
    const token = store.state.auth.token
    const response = await getTrainingDocumentGroups(token)
    setResults(response)
    selectFirstSubGroup()
    isLoading.value = false
}

loadTrainingDocuments()

</script>